import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ScrollUp from '../elements/ScrollUp'
import ToMain from '../elements/ToMain'

export default function AppPage({children}) {
  return (
    <>
    <Navbar />
    {children}
    <Footer />
    <ScrollUp />
    <ToMain />
    </>
  )
}
